import { render } from "./IconFacebook.vue?vue&type=template&id=397d46d4&scoped=true&ts=true"
import script from "./IconFacebook.vue?vue&type=script&lang=ts"
export * from "./IconFacebook.vue?vue&type=script&lang=ts"

import "./IconFacebook.vue?vue&type=style&index=0&id=397d46d4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397d46d4"]])

export default __exports__